import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useDashboard(data = {}) {
  const { enabled = false, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getDashboardData() {
    return privateFetch.get(`/v1/admin/dashboard`, configs).then((res) => res.data);
  }

  return useQuery(['user-review-item-stats', { ...(configs?.params || {}) }], getDashboardData, {
    enabled,
  });
}

export default useDashboard;
